/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Cannot_Remove_PlayersInputs */



/**
* | output |
* | --- |
* | "Cannot remove players in this state" |
*
* @param {Err_Tournament_Cannot_Remove_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_cannot_remove_players = /** @type {((inputs?: Err_Tournament_Cannot_Remove_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Cannot_Remove_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de retirer des joueurs dans cet état")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pueden eliminar jugadores en este estado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível remover jogadores neste estado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile rimuovere giocatori in questo stato")
	return /** @type {LocalizedString} */ ("Cannot remove players in this state")
});